import { twMerge } from 'tailwind-merge';

import { Label, RadioGroup, RadioGroupItem } from '@/_components';

export function FilterTypeSelector({
  types,
  type,
  setType,
  className = 'mt-4',
}: {
  types: { name: string; value: string }[];
  type: string | null;
  setType: (type: string | null) => void;
  className?: string;
}) {
  return (
    <RadioGroup className={twMerge(className, 'gap-3')} value={type} onValueChange={setType}>
      {types.map((type) => (
        <div key={type.value} className="flex items-center space-x-2 pl-0.5">
          <RadioGroupItem value={type.value} id={type.value} />
          <Label htmlFor={type.value}>{type.name}</Label>
        </div>
      ))}
    </RadioGroup>
  );
}
